import { Editor } from '@tiptap/react'
import { Flex } from 'antd'

import { BackgroundColorButton } from './BackgroundColorButton'
import { LinkButton } from './LinkButton'
import { MarkButton } from './MarkButton'
import { TextColorButton } from './TextColorButton'

type Props = {
  editor: Editor
}

export const MenuHighlightButtons = ({ editor }: Props) => {
  return (
    <Flex gap="8px">
      <TextColorButton editor={editor} />
      <BackgroundColorButton editor={editor} />
      <MarkButton editor={editor} />
      <LinkButton editor={editor} />
    </Flex>
  )
}
